import React from "react";
import { Line } from "react-chartjs-2";
import { connect } from "react-redux";

import {
    Card,
    CardBody,
    CardHeader,
    CardTitle,
} from "reactstrap";

const SummaryChart = ({ theme, inputData }) => {
    let labels = [], leads = [], matched = [], revenue = [], cost = [], profit = []

    for (let index = inputData.length-1; index >= 0; --index) {
        const element = inputData[index];
        labels.push(element.date)
        leads.push(element.leads)
        matched.push(element.matched)
        revenue.push(element.total)
        cost.push(element.publisher);
        profit.push((Number(element.total) - Number(element.publisher)).toFixed(2));
    }

    const data = {
        labels: labels,
        datasets: [
            {
                label: "Leads",
                fill: true,
                backgroundColor: "transparent",
                borderColor: theme.primary,
                data: leads
            },
            {
                label: "Matched",
                fill: true,
                backgroundColor: "transparent",
                borderColor: theme.success,
                data: matched
            },
            {
                label: "Revenue",
                fill: true,
                backgroundColor: "transparent",
                borderColor: theme.secondary,
                data: revenue
            },
            {
                label: "Cost",
                fill: true,
                backgroundColor: "transparent",
                borderColor: theme.warning,
                data: cost
            },
            {
                label: "Profit",
                fill: true,
                backgroundColor: "transparent",
                borderColor: theme.info,
                data: profit
            }
        ]
    };

    const options = {
        maintainAspectRatio: false,
        legend: {
            display: true
        },
        tooltips: {
            intersect: false
        },
        hover: {
            intersect: true
        },
        plugins: {
            filler: {
                propagate: false
            }
        },
        scales: {
            xAxes: [
                {
                    reverse: true,
                    gridLines: {
                        color: "rgba(0,0,0,0.05)"
                    }
                }
            ],
            yAxes: [
                {
                    ticks: {
                        stepSize: 500
                    },
                    display: true,
                    borderDash: [5, 5],
                    gridLines: {
                        color: "rgba(0,0,0,0)",
                        fontColor: "#fff"
                    }
                }
            ]
        }
    };

    return (
        <Card className="flex-fill w-100">
            <CardHeader>
                <CardTitle tag="h5" className="mb-0">
                    Total Revenue
                </CardTitle>
            </CardHeader>
            <CardBody>
                <div className="chart">
                    <Line data={data} options={options} />
                </div>
            </CardBody>
        </Card>
    );
};

export default connect(store => ({
    theme: store.theme.currentTheme
}))(SummaryChart);
